import { memo } from 'react'

/**
 * `React.memo` that PRESERVES a generic component's call signature.
 *
 * `memo`'s own types return `MemoExoticComponent<T>`, which resolves a generic component's
 * props at their constraint and erases the type parameter — so a memoized
 * `<TData,>(props: Props<TData>) => ReactNode` stops inferring `TData` at its call sites.
 * No annotation recovers it; a cast is the only expression of the identity `memo` actually
 * has at runtime, which is why it lives HERE, once and explained, instead of at each
 * generic-memo site (`.agents/rules/typescript/house-style.md` bans `as X` — this is the one
 * sanctioned instance for this pattern, and containing it keeps the count at one).
 */
export const genericMemo = memo as <TComponent>(component: TComponent) => TComponent
